import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    title: 'LLC Blindada',
    description: 'Protección legal desde el día 1. Separa tus bienes personales de los riesgos del negocio con la estructura correcta.'
  }, {
    title: 'Crédito Business',
    description: 'Accede a líneas de crédito de hasta $100k sin usar tu garantía personal, apalancando el dinero del banco.'
  }, {
    title: 'Delegación Operativa',
    description: 'Automatiza procesos y delega tareas clave para que puedas operar como un verdadero CEO, no como un empleado más.'
  }];
  return <section className="py-8 md:py-14 bg-navy text-white relative overflow-hidden" data-id="element-144">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-145" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-146" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-147">
        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-149">
            <h2 className="text-3xl md:text-4xl mb-6" data-id="element-150">Lo Que Vas a Lograr</h2>
            <p className="text-gray-300 text-lg mb-8 font-body" data-id="element-151">
              El sistema{' '}
              <span className="text-gold font-bold" data-id="element-152">Imperio Americano</span>{' '}
              está diseñado paso a paso para llevarte de operador cansado a
              dueño de negocio estructurado.
            </p>

            <div className="space-y-6" data-id="element-153">
              {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.2
            }} className="flex items-start gap-4" data-id="element-154">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-1" data-id="element-155" />
                  <div data-id="element-156">
                    <h3 className="text-xl font-bold text-white mb-1" data-id="element-157">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-158">{benefit.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Abstract visual representation */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[300px] md:h-[350px] rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 md:p-8 flex flex-col justify-center" data-id="element-159">
            <div className="space-y-4" data-id="element-160">
              {[100, 75, 50].map((width, i) => <motion.div key={i} initial={{
              width: 0
            }} whileInView={{
              width: `${width}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5 + i * 0.2
            }} className="h-12 rounded-lg bg-gradient-to-r from-gold/80 to-gold/20 flex items-center px-4" data-id="element-161">
                  <div className="w-2 h-2 rounded-full bg-white/50" data-id="element-162" />
                </motion.div>)}
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent rounded-2xl" data-id="element-163" />
            <p className="absolute bottom-8 left-8 right-8 text-center text-sm font-heading text-gold tracking-widest uppercase" data-id="element-164">
              Crecimiento Estructurado
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}